// Enums for Focuzon

// Session Types
export enum SessionType {
  FOCUS = 'focus',
  BREAK = 'break',
  LONG_BREAK = 'long-break',
}

// Session Modes
export enum SessionMode {
  SOLO = 'solo',
  TEAM = 'team',
}

// Theme Types
export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

// Productivity Trend
export enum ProductivityTrend {
  UP = 'up',
  DOWN = 'down',
  STABLE = 'stable',
}

// Room Privacy
export enum RoomPrivacy {
  PUBLIC = 'public',
  PRIVATE = 'private',
}

// Room Status
export enum RoomStatus {
  WAITING = 'waiting',
  ACTIVE = 'active',
  ENDED = 'ended',
}

// Analytics Period
export enum AnalyticsPeriod {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

// Session Filter
export enum SessionFilter {
  ALL = 'all',
  SOLO = 'solo',
  TEAM = 'team',
}

// Reminder Type
export enum ReminderType {
  EYE = 'eye',
  MIND = 'mind',
  PHYSICAL = 'physical',
  COGNITIVE = 'cognitive',
  CUSTOM = 'custom',
}

// Game Difficulty
export enum GameDifficulty {
  EASY = 'easy',
  MEDIUM = 'medium',
  HARD = 'hard',
}

// Button Variant
export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  GHOST = 'ghost',
  DESTRUCTIVE = 'destructive',
}

// Button Size
export enum ButtonSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

// Spinner Size
export enum SpinnerSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

// HTTP Method
export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

// User Role
export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
}

// Social Media Provider
export enum SocialProvider {
  GOOGLE = 'google',
  TWITTER = 'twitter',
}

// Game Category
export enum GameCategory {
  CALMING = 'calming',
  COGNITIVE = 'cognitive',
  FRUSTRATION = 'frustration',
  PUZZLES = 'puzzles',
}

// Game ID
export enum GameId {
  BREATHING_BUBBLE = 'breathing-bubble',
  ZEN_GARDEN = 'zen-garden',
  WATER_RIPPLE = 'water-ripple',
  COLOR_FLOW = 'color-flow',
  MEMORY_FLIP = 'memory-flip',
  FOCUS_DOT = 'focus-dot',
  REACTION_TEST = 'reaction-test',
  PATTERN_BUILDER = 'pattern-builder',
  BUBBLE_POPPER = 'bubble-popper',
  GLASS_SMASH = 'glass-smash',
  STRESS_BALL = 'stress-ball',
  TYPING_RAGE = 'typing-rage',
  WHACK_STRESS = 'whack-stress',
  JIGSAW_MINI = 'jigsaw-mini',
  FocusGrid = 'focus-grid',
  WORD_CLOUD = 'word-cloud',
}

